module.exports = __webpack_public_path__ + "01e709e356b8a3d21f85be89578bc9ed.jpg";